export default __webpack_public_path__ + "static/media/ArticDiesel.a6c99542.svg";